import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tapList: [
      {
        name: '首页',
        underlineFlag: true,
        navColFlg: '',
        idNum: '99',
        url: 'myHome',
        id: '99-1',
      },
      // {
      //   name: "商城",
      //   underlineFlag: false,
      //   navColFlg: "",
      //   idNum: "1",
      //   url: "InquiryForm",
      //   children: [
      //     {
      //       name: "安全手机",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "1-1",
      //       url: "InquiryForm",
      //     },
      //   ],
      // },
      {
        name: '企业服务',
        underlineFlag: false,
        navColFlg: '',
        idNum: '2',
        url: '/static/companyService',
        children: [
          {
            name: '企业安全通讯与系统',
            underlineFlag: false,
            navColFlg: '',
            idNum: '2-1',
            url: '',
            children: [
              {
                tit: '企业集群安全通讯',
                underlineFlag: false,
                navColFlg: '',
                idNum: '2-1-1',
                txt: '内容',
                url: '/static/detail/enterpriseClusterSecurityCommunication',
              },
              {
                tit: '终端双域操作系统',
                underlineFlag: false,
                navColFlg: '',
                idNum: '2-1-2',
                txt: '测试内容',
                url: '/static/detail/dualDomainSystem',
              },
              {
                "id": 999,
                underlineFlag: false,
                tit: "企业私有通讯系统",
                idNum: "2-1-3",
                url: "/static/detail/enterprisePrivateCommunicationSystem",
                text: ''
              }
            ],
          },
          // {
          //   name: '集团通讯',
          //   underlineFlag: false,
          //   navColFlg: '',
          //   idNum: '2-2',
          //   url: 'enterpriseHome/enterpriseMobileComm',
          // },
          {
            name: '企业移动办公自动化',
            underlineFlag: false,
            navColFlg: '',
            idNum: '2-3',
            url: '',
            children: [
              {
                tit: '移动安全办公系统',
                underlineFlag: false,
                navColFlg: '',
                idNum: '2-3-1',
                txt: '内容',
                url: '/static/detail/safeOffice',
              }
            ],
          },
          {
            name: '企业信息化管理',
            underlineFlag: false,
            navColFlg: '',
            idNum: '2-4',
            url: '',
            children: [
              {
                "id": 996,
                "tit": "企业数据管理EMM",
                underlineFlag: false,
                navColFlg: '',
                "idNum": "2-4-1",
                url: "/static/detail/EMM",
              },
              {
                "id": 997,
                tit: "物联网管理系统",
                underlineFlag: false,
                navColFlg: '',
                idNum: "2-4-2",
                url: "/static/detail/iotSystem",
              }
            ]
          },
          {
            name: '企业安全定制',
            underlineFlag: false,
            navColFlg: '',
            idNum: '2-5',
            url: '',
            children: [
              {
                "id": 995,
                "tit": "移动终端定制",
                "idNum": "2-5-1",
                "url": "/static/detail/mobileTerminalCustom",
                "tableName": "jingshu_category"
              },
              {
                "id": 994,
                "tit": "智能设备定制",
                "idNum": "2-5-2",
                "url": "/static/detail/intelligentDeviceCustom",
                "tableName": "jingshu_category"
              },
              {
                "id": 993,
                "tit": "安全系统定制",
                "idNum": "2-5-3",
                "url": "/static/detail/safeSystemCustom",
                "tableName": "jingshu_category"
              },
              {
                "id": 992,
                "tit": "安全软件定制",
                "idNum": "2-5-4",
                "url": "/static/detail/safeSoftwareCustom",
                "tableName": "jingshu_category"
              }
            ]
          },
          {
            name: '企业采购方案',
            underlineFlag: false,
            navColFlg: '',
            idNum: '2-8',
            url: '',
            "children": [
              {
                "id": 991,
                "tit": "月付模式",
                "idNum": "2-8-1",
                "url": '/static/detail/payByMonth',
                "tableName": "jingshu_category"
              },
              {
                "id": 990,
                "tit": "一次性买断",
                "idNum": "2-8-2",
                "url": '/static/detail/payOneTime',
                "tableName": "jingshu_category"
              },
              {
                "id": 989,
                "tit": "分期付款",
                "idNum": "2-8-3",
                "url": '/static/detail/paySplit',
                "tableName": "jingshu_category"
              },
              {
                "id": 988,
                "tit": "研发后置",
                "idNum": "2-8-4",
                "url": '/static/detail/payBefore',
                "tableName": "jingshu_category"
              }
            ]
          },
        ],
      },
      {
        name: '政务服务',
        underlineFlag: false,
        navColFlg: '',
        idNum: '3',
        url: 'goveHome',
        children: [
          {
            name: '系统集成与系统统一化定制',
            underlineFlag: false,
            navColFlg: '',
            idNum: '3-1',
            url: '/static/detail/systemCustom',
          },
          {
            name: '政务EMM管理',
            underlineFlag: false,
            navColFlg: '',
            idNum: '3-2',
            url: '/static/detail/goveEMM',
          },
          {
            name: '私有集团安全通讯解决方案',
            underlineFlag: false,
            navColFlg: '',
            idNum: '3-3',
            url: '/static/detail/privateSafe',
          },
          {
            name: '专业安全软件定制',
            underlineFlag: false,
            navColFlg: '',
            idNum: '3-4',
            url: '/static/detail/professionalSecuritySoftware',
          },
          {
            name: '非制式安全终端定制',
            underlineFlag: false,
            navColFlg: '',
            idNum: '3-5',
            url: '/static/detail/nonStandardSecurityTerminalCustom',
          },
          {
            name: '移动政务解决方案',
            underlineFlag: false,
            navColFlg: '',
            idNum: '3-6',
            url: '/static/detail/mobileGovernmentSolution',
          },
        ],
      },
      {
        name: '定制服务',
        underlineFlag: false,
        navColFlg: '',
        idNum: '4',
        url: 'customizeHome',
        // children: [
        //   {
        //     name: "企业定制服务",
        //     underlineFlag: false,
        //     navColFlg: "",
        //     idNum: "4-1",
        //     url: "customizeHome/customizeEnterprise",
        //   },
        //   {
        //     name: "私人定制服务",
        //     underlineFlag: false,
        //     navColFlg: "",
        //     idNum: "4-2",
        //     url: "customizeHome/customizePrivate",
        //   },
        // ],
      },
      {
        name: '产品',
        underlineFlag: false,
        navColFlg: "",
        idNum: "5",
        url: "/static/products",//systemProduct  productHome
        children:[
          {
            name: '系统产品',
            underlineFlag: false,
            navColFlg: '',
            idNum: '5-1',
            url: '/static/products?type=1',
          },
          {
            name: '软件产品',
            underlineFlag: false,
            navColFlg: '',
            idNum: '5-2',
            url: '/static/products?type=2',
          },
          {
            name: '硬件产品',
            underlineFlag: false,
            navColFlg: '',
            idNum: '5-3',
            url: '/static/products?type=3',
          },
        ]
        // children: [
        // {
        //   name: "京数应用商店",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-1",
        //   url: "systemProduct/vargoAppStore",
        // },
        // {
        //   name: "原EMM设备数据智能管理系统",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-2",
        //   url: "systemProduct/systemEMMdevice",
        // },
        // {
        //   name: "京数云系统",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-3",
        //   url: "systemProduct/systemCloud",
        // },



        // {
        //   name: "密信",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-4",
        //   url: "systemProduct",
        // },
        // {
        //   name: "安全相册",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-5",
        //   url: "systemProduct",
        // },
        // {
        //   name: "平行线-资源管理",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-6",
        //   url: "systemProduct",
        // },
        // {
        //   name: "安全对讲",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-7",
        //   url: "systemProduct",
        // },
        // {
        //   name: "音视会议",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-8",
        //   url: "systemProduct",
        // },
        // {
        //   name: "安全传输",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-9",
        //   url: "systemProduct",
        // },
        // {
        //   name: "京数 云",
        //   underlineFlag: false,
        //   navColFlg: "",
        //   idNum: "5-0",
        //   url: "systemProduct",
        // },
        // ],
      },
      // {
      //   name: "服务",
      //   underlineFlag: false,
      //   navColFlg: "",
      //   idNum: "6",
      //   url: "serviceHome",
      //   children: [
      //     {
      //       name: "售后服务",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "6-1",
      //       url: "serviceHome/afterSalesService",
      //     },
      //     {
      //       name: "驱动下载",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "6-2",
      //       url: "serviceHome",
      //     },
      //     {
      //       name: "京数应用",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "6-2",
      //       url: "serviceHome",
      //     },
      //   ],
      // },
      {
        name: '关于京数',
        underlineFlag: false,
        navColFlg: "",
        idNum: "7",
        url: "aboutUs",
        // children: [
        //   {
        //     name: "公司简介",
        //     underlineFlag: false,
        //     navColFlg: "",
        //     idNum: "7-1",
        //     url: "aboutUs/companyIntro",
        //   },
        //   {
        //     name: "团队介绍",
        //     underlineFlag: false,
        //     navColFlg: "",
        //     idNum: "7-2",
        //     url: "aboutUs",
        //   },
        //   {
        //     name: "企业架构介绍",
        //     underlineFlag: false,
        //     navColFlg: "",
        //     idNum: "7-3",
        //     url: "aboutUs",
        //   },
        // ],
      },
      // {
      //   name: "人才计划",
      //   underlineFlag: false,
      //   navColFlg: "",
      //   idNum: "8",
      //   url: "InquiryForm",
      // },
      // {
      //   name: "硬件产品",
      //   underlineFlag: false,
      //   navColFlg: "",
      //   idNum: "11",
      //   url: "InquiryForm",
      //   children: [
      //     {
      //       name: "京数卓越IV安全手机",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "11-1",
      //       url: "InquiryForm",
      //     },
      //     {
      //       name: "24寸一体机",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "11-2",
      //       url: "InquiryForm",
      //     },
      //     {
      //       name: "34寸一体机",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "11-3",
      //       url: "InquiryForm",
      //     },
      //     {
      //       name: "配件产品",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "11-4",
      //       url: "InquiryForm",
      //     },
      //   ],
      // },
      // {
      //   name: "企业福利",
      //   underlineFlag: false,
      //   navColFlg: "",
      //   idNum: "9",
      //   url: "talentsScheme",
      //   children: [
      //     {
      //       name: "项目奖励",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "9-1",
      //       url: "aboutUs",
      //     },
      //     {
      //       name: "平台奖励",
      //       underlineFlag: false,
      //       navColFlg: "",
      //       idNum: "9-2",
      //       url: "aboutUs",
      //     },
      //   ],
      // },
    ],
    enterp_somFlg: '',
    treeList: [
      {
        "id": 1,
        "label": "企业服务",
        "idNum": "2",
        "routingPath": "/static/companyService",
        "tableName": "jingshu_category",
        "children": [
          {
            "id": 6,
            "label": "企业安全通讯与系统",
            "idNum": "2-1",
            "routingPath": "",
            "tableName": "jingshu_category",
            "children": [
              {
                "id": 8,
                "label": "企业集群安全通讯",
                "idNum": "2-1-1",
                "routingPath": "/static/detail/enterpriseClusterSecurityCommunication",
                "tableName": "jingshu_category"
              },
              {
                "id": 21,
                "label": "终端双域操作系统",
                "idNum": "2-1-2",
                "routingPath": "/static/detail/dualDomainSystem",
                "tableName": "jingshu_category"
              },
              {
                "id": 999,
                "label": "企业私有通讯系统",
                "idNum": "2-1-3",
                "routingPath": "/static/detail/enterprisePrivateCommunicationSystem",
                "tableName": "jingshu_category"
              }
            ]
          },
          // {
          //   "id": 9,
          //   "label": "企业私有通讯系统",
          //   "idNum": "2-2",
          //   "routingPath": "enterpriseHome/enterpriseMobileComm",
          //   "tableName": "jingshu_category"
          // },
          {
            "id": 10,
            "label": "企业移动办公自动化",
            "idNum": "2-3",
            "routingPath": "",
            "tableName": "jingshu_category",
            "children": [
              {
                "id": 998,
                "label": "移动安全办公系统",
                "idNum": "2-3-1",
                "routingPath": "/static/detail/safeOffice",
                "tableName": "jingshu_category"
              }
            ]
          },
          {
            "id": 11,
            "label": "企业信息化管理",
            "idNum": "2-4",
            "routingPath": "",
            "tableName": "jingshu_category",
            "children": [
              {
                "id": 996,
                "label": "企业数据管理EMM",
                "idNum": "2-4-1",
                "routingPath": "/static/detail/EMM",
                "tableName": "jingshu_category"
              },
              {
                "id": 997,
                "label": "物联网管理系统",
                "idNum": "2-4-2",
                "routingPath": "/static/detail/iotSystem",
                "tableName": "jingshu_category"
              }
            ]
          },
          {
            "id": 12,
            "label": "企业安全定制",
            "idNum": "2-5",
            "routingPath": "",
            "tableName": "jingshu_category",
            "children": [
              {
                "id": 995,
                "label": "移动终端定制",
                "idNum": "2-5-1",
                "routingPath": "/static/detail/mobileTerminalCustom",
                "tableName": "jingshu_category"
              },
              {
                "id": 994,
                "label": "智能设备定制",
                "idNum": "2-5-2",
                "routingPath": "/static/detail/intelligentDeviceCustom",
                "tableName": "jingshu_category"
              },
              {
                "id": 993,
                "label": "安全系统定制",
                "idNum": "2-5-3",
                "routingPath": "/static/detail/safeSystemCustom",
                "tableName": "jingshu_category"
              },
              {
                "id": 992,
                "label": "安全软件定制",
                "idNum": "2-5-4",
                "routingPath": "/static/detail/safeSoftwareCustom",
                "tableName": "jingshu_category"
              }
            ]
          },
          {
            "id": 18,
            "label": "企业采购方案",
            "idNum": "2-8",
            "routingPath": "",
            "tableName": "jingshu_category",
            "children": [
              {
                "id": 991,
                "label": "月付模式",
                "idNum": "2-8-1",
                "routingPath": '/static/detail/payByMonth',
                "tableName": "jingshu_category"
              },
              {
                "id": 990,
                "label": "一次性买断",
                "idNum": "2-8-2",
                "routingPath": '/static/detail/payOneTime',
                "tableName": "jingshu_category"
              },
              {
                "id": 989,
                "label": "分期付款",
                "idNum": "2-8-3",
                "routingPath": '/static/detail/paySplit',
                "tableName": "jingshu_category"
              },
              {
                "id": 988,
                "label": "研发后置",
                "idNum": "2-8-4",
                "routingPath": '/static/detail/payBefore',
                "tableName": "jingshu_category"
              }
            ]
          }
        ]
      },
      {
        "id": 22,
        "label": "政务服务",
        "idNum": "3",
        "routingPath": "goveHome",
        "tableName": "jingshu_category",
        "children": [
          {
            "id": 23,
            "label": "系统集成与系统统一化定制",
            "idNum": "3-1",
            "routingPath": "/static/detail/systemCustom",
            "tableName": "jingshu_category"
          },
          {
            "id": 24,
            "label": "政务EMM管理",
            "idNum": "3-2",
            "routingPath": "/static/detail/goveEMM",
            "tableName": "jingshu_category"
          },
          {
            "id": 25,
            "label": "私有集团安全通讯解决方案",
            "idNum": "3-3",
            "routingPath": "/static/detail/privateSafe",
            "tableName": "jingshu_category"
          },
          {
            "id": 26,
            "label": "专业安全软件定制",
            "idNum": "3-4",
            "routingPath": "/static/detail/professionalSecuritySoftware",
            "tableName": "jingshu_category"
          },
          {
            "id": 27,
            "label": "非制式安全终端定制",
            "idNum": "3-5",
            "routingPath": "/static/detail/nonStandardSecurityTerminalCustom",
            "tableName": "jingshu_category"
          },
          {
            "id": 28,
            "label": "移动政务解决方案",
            "idNum": "3-6",
            "routingPath": "/static/detail/mobileGovernmentSolution",
            "tableName": "jingshu_category"
          }
        ]
      },
      {
        "id": 29,
        "label": "定制服务",
        "idNum": "4",
        "routingPath": "customizeHome",
        "tableName": "jingshu_category",
        "children": [
          {
            "id": 6,
            "label": "私人定制",
            "idNum": "4-1",
            "routingPath": "customizeHome/customizeEnterprise",
            "tableName": "jingshu_category"
          },
          {
            "id": 59,
            "label": "企业定制",
            "idNum": "4-2",
            "routingPath": "customizeHome/customizeEnterprise",
            "tableName": "jingshu_category"
          }
        ]
      },
      {
        "id": 32,
        "label": "产品",
        "idNum": "5",
        "routingPath": "/static/products",
        "tableName": "jingshu_category",
        "children": [
          {
            "id": 7,
            "label": "系统产品",
            "idNum": "5-1",
            "routingPath": '/static/products?type=1',
            "tableName": "jingshu_category",
            // "children": [
            //   {
            //     "id": 162,
            //     "label": "EMM设备数据智能管理系统",
            //     "idNum": "5-1-1",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 20,
            //     "label": "京数云系统",
            //     "idNum": "5-1-2",
            //     "routingPath": "productHome/kyosuyun",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 21,
            //     "label": "企业移动办公系统",
            //     "idNum": "5-1-3",
            //     "routingPath": "productHome/productMobileOffice",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 22,
            //     "label": "FOTA系统",
            //     "idNum": "5-1-4",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 161,
            //     "label": "推送系统",
            //     "idNum": "5-1-5",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 19,
            //     "label": "物联网管控系统",
            //     "idNum": "5-1-6",
            //     "routingPath": "productHome/productEmm",
            //     "tableName": "jingshu_menu_details"
            //   }
            // ]
          },
          {
            "id": 8,
            "label": "软件产品",
            "idNum": "5-2",
            "routingPath": '/static/products?type=2',
            "tableName": "jingshu_category",
            // "children": [
            //   {
            //     "id": 24,
            //     "label": "JINGSHU OS",
            //     "idNum": "5-2-1",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 25,
            //     "label": "安全电话",
            //     "idNum": "5-2-2",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 26,
            //     "label": "安全短信",
            //     "idNum": "5-2-3",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 168,
            //     "label": "Vtime",
            //     "idNum": "5-2-10",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 27,
            //     "label": "安全对讲",
            //     "idNum": "5-2-4",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 28,
            //     "label": "安全会议",
            //     "idNum": "5-2-5",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 29,
            //     "label": "安全传输",
            //     "idNum": "5-2-6",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 30,
            //     "label": "安全空间",
            //     "idNum": "5-2-7",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 31,
            //     "label": "照片管理",
            //     "idNum": "5-2-8",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 32,
            //     "label": "我是党员",
            //     "idNum": "5-2-9",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   }
            // ]
          },
          {
            "id": 9,
            "label": "硬件产品",
            "idNum": "5-3",
            "routingPath": '/static/products?type=3',
            "tableName": "jingshu_category",
            // "children": [
            //   {
            //     "id": 167,
            //     "label": "VNAS私有服务器",
            //     "idNum": "5-3-5",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 166,
            //     "label": "安全电脑",
            //     "idNum": "5-3-4",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 165,
            //     "label": "安全手机",
            //     "idNum": "5-3-3",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 164,
            //     "label": "5G天通卫星手机",
            //     "idNum": "5-3-2",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   },
            //   {
            //     "id": 163,
            //     "label": "高安全手机",
            //     "idNum": "5-3-1",
            //     "routingPath": "detailTempIndex/templateDetail",
            //     "tableName": "jingshu_menu_details"
            //   }
            // ]
          }
        ]
      },
      {
        "id": 34,
        "label": "关于京数",
        "idNum": "7",
        "routingPath": "aboutUs",
        "tableName": "jingshu_category",
        "children": [
          {
            "id": 36,
            "label": "公司简介",
            "idNum": "7-1",
            "routingPath": "aboutUs/companyIntro",
            "tableName": "jingshu_category"
          },
          {
            "id": 61,
            "label": "成为合作伙伴",
            "idNum": "7-4",
            "routingPath": "aboutJingshu/partnerIndex",
            "tableName": "jingshu_category"
          },
          {
            "id": 39,
            "label": "招贤纳士",
            "idNum": "7-4",
            "routingPath": "aboutJingshu/recruitment",
            "tableName": "jingshu_category"
          }
        ]
      }
    ],
    treeContInfo: {},
  },
  getters: {},
  mutations: {
    changeTabCheck(state, payload) {
      let sumId = '';
      if (payload.idNum.charAt(1) == '-') {
        sumId = payload.idNum.charAt(0);
      }
      let numId = '';
      if (payload.idNum.charAt(3) == '-') {
        numId = payload.idNum.substring(0, 3);
      }

      state.tapList.forEach((item, index) => {
        if (
          item.idNum == payload.idNum ||
          item.idNum == sumId ||
          item.url == payload.sumName
        ) {
          item.underlineFlag = true;
        } else {
          item.underlineFlag = false;
        }
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2, index2) => {
            if (
              item2.idNum == payload.idNum ||
              item2.idNum == numId ||
              item2.url == payload.sumName
            ) {
              item2.underlineFlag = true;
            } else {
              item2.underlineFlag = false;
            }
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3, index3) => {
                if (
                  item3.idNum == payload.idNum ||
                  item3.url == payload.sumName
                ) {
                  item3.underlineFlag = true;
                  item3.avColFlg = '';
                } else {
                  item3.underlineFlag = false;
                }
              });
            }
          });
        }
      });
      // console.log(state.tapList,payload, "测试数据vuex");
    },
  },
  actions: {},
  modules: {},
});
